<template>
  <div>
    <div v-if="ativo == null">
      <div class="d-flex justify-content-end">
          <b-button 
            class="mr-3" 
            variant="danger"
            @click="$refs.videoManual.toggleOpen({ 
              url: 'https://www.youtube.com/watch?v=KuVcon3Hg48&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=29', 
              title: 'Redes sociais' 
            })"
          >
            <i class="fas fa-play mr-1"></i>
            Ver video
          </b-button>
        </div>

      <artes-rede-sociais></artes-rede-sociais>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-12">
          <h1 class="font-weight-bold text-uppercase" id="inicio">Minhas artes</h1>
          <hr class="linha-amarela" />
          <hr />
        </div>
        <div class="d-flex justify-content-end">
          <b-button 
            class="mr-3" 
            variant="danger"
            @click="$refs.videoManual.toggleOpen({ 
              url: 'https://www.youtube.com/watch?v=KuVcon3Hg48&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=29', 
              title: 'Redes sociais'
            })"
          >
            <i class="fas fa-play mr-1"></i>
            Ver video
          </b-button>
        </div>
        <div class="col-md-12 mt-4">
          <h4><b>Plano atual:</b> {{ativo.nome}} </h4>
          <p> {{ativo.descricao}} </p>
          <h5 class="mt-4">Suas imagens disponíveis</h5>
          <div class="row" v-for="(itemImagens, i) in imagens" :key="i">
            <div class="col-md-2 mb-2" v-for="(item, i) in itemImagens" :key="i">
              <img :src="url(item)" width="100%">
              <button class="btn btn-success btn-block" @click="download(url(item))">Abrir imagem</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ArtesRedeSociais from './ArtesRedeSociais.vue';
import VideoManual from '@/components/VideoManual.vue';
export default {
  name:'index',
  components: {
    ArtesRedeSociais,
    VideoManual
  },

    data() {
    return {
      ativo: null,
      imagens: null
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.showPlanosId();
    this.get();
  },

  methods: {
    url(url) {
      return process.env.VUE_APP_IMAGES_ADDRESS+url;
    },
    download(url) {
      var el = document.createElement("a");
      el.setAttribute("href", url);
      el.setAttribute("target", '_ablank');
      el.setAttribute("download", 'teste.png');
      document.body.appendChild(el);
      el.click();
      el.remove();
    },

    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/minhaImagensPlano', this.dadosUsuario.id)
      .then((response) => {
        const data = response.data;
        this.imagens = data.reduce((obj, {semana, url_img}) => {
          if (!obj[semana]) obj[semana] = [];
          obj[semana].push(url_img);
          return obj;
        }, {});
        
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    showPlanosId() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/planoId', this.dadosUsuario.id)
      .then((response) => {
        if(response.data.id) {
          this.ativo = response.data;
        }        
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
  }
}
</script>

<style scoped>

</style>